import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';
import { VTSTroubleshootService } from "../models/vehicletroubleshoot.service";
import { VehicleModel } from "../../vehicle/models/vehicle.model";
import { VehicleService } from "../../vehicle/models/vehicle.service";
import { VTSTroubleshootModel } from "../models/vts-troubleshoot.model";

@Component({
  selector: 'wego-vts-troubleshoot',
  template: require('../views/vts-troubleshoot.component.html'),
  providers: [VTSTroubleshootService, VehicleService],
  styles: [
    `
    .alert{
      margin-bottom: 0px;
    }
    .alert-default{
      background-color: #2BA2AA;
    }
    `
  ]
})
export class VTSTroubleshootComponent implements OnInit {
  vehicleHashId: string;
  popupTitle: string;
  DataListModel: DataListModel;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  serviceStatus: any;
  VehicleObuStatusList: VTSTroubleshootModel;
  urlVtsHistory: string;
  urlVehicleInfo: string;
  urlVtsVehicleUpdate: string;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild('successPopup') public successPopup: any;

  constructor(private vtsTroubleshootService: VTSTroubleshootService,
    private translate: TranslateService,
    private authService: AuthService, private activeRoute: ActivatedRoute,
    private router: Router, private vehicleService: VehicleService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblTroubleShootVTS');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["LicenceTag", "VTSDoorStatus", "VTSLastLatitude", "VTSLastLongitude"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.urlVtsHistory = this.authService.GetURL(ApplicationRouteURL.URL_VTS_HISTORY_LIST);
    this.urlVehicleInfo = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLE_INFO);
    this.urlVtsVehicleUpdate = this.authService.GetURL(ApplicationRouteURL.URL_VTSVEHICLE_UPDATE);
    this.activeRoute
      .params
      .subscribe(params => {
        this.vehicleHashId = params['id'] ? params['id'] : params['vehicleHashId'];
        this.GetVehicleObuStatus();
        this.GetServiceStatus();
      });
  }

  public GetServiceStatus() {
    this.isLoading = true;
    this.vtsTroubleshootService.GetVTSStatus()
      .subscribe(
        (res1: any) => {
          this.serviceStatus = res1.data;
          this.isLoading = false;
        },
        (error1: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error1);
          this.isLoading = false;
        });
  }

  public GetVehicleObuStatus() {
    this.isLoading = true;
    this.vtsTroubleshootService.GetVehicleObuStatus(this.DataListModel, this.vehicleHashId)
      .subscribe(
        (res: any) => {
          this.VehicleObuStatusList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public LockVTSVehicle(locationDataExchangeHashId: string) {
    this.isLoading = true;
    this.vehicleService.LockVTSVehicle(locationDataExchangeHashId, false)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            this.popupMsg = this.translate.instant('LblLockSuccessfully');
            this.ShowSuccessPopup();
          }
          else {

            if (res.error.toUpperCase() == "ACTION ABORTED, ENGINE STILL RUNNING") {
              this.popupMsg = this.translate.instant("LblEngineStillRunning");
              this.popupTitle = this.translate.instant("LblWarning");
            } else {
              this.popupMsg = this.translate.instant('LbllockProblem');
              this.popupTitle = this.translate.instant('LblWarning');
            }

            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });
  }

  public UnLockVTSVehicle(locationDataExchangeHashId: string) {
    this.isLoading = true;
    this.vehicleService.UnLockVTSVehicle(locationDataExchangeHashId, false)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            this.popupMsg = this.translate.instant('LblUnLockSuccessfully');
            this.ShowSuccessPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblUnlockProblem');
            this.popupTitle = this.translate.instant('LblWarning');
            this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.popupTitle = this.popupTitle;
    this.successPopup.popupMsg = this.popupMsg;
    this.successPopup.show();

  }

  public ConfirmSuccessPopup(): void {
    this.GetVehicleObuStatus();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleObuStatus();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleObuStatus();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetVehicleObuStatus();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleObuStatus();
  };

  public OnExport(event: any) {
    this.isLoading = true;
    this.vtsTroubleshootService.ExportVehicleObuStatus(this.DataListModel, this.vehicleHashId)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "VehcleObuStatus" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vts-troubleshoot/components/vts-troubleshoot.component.ts